import React from 'react'
import clsx from 'clsx'
import BookingAttachmentCard from './components/booking-attachment-card'

const getHostFromURL = url => {
  if (!url) return null

  const [trimmedUrl] = url
    .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
    .split('/')
  return trimmedUrl || null
}

const UnableToRenderCard = ({ type }) => (
  <div
    className={clsx('str-chat__message-attachment-card', {
      [`str-chat__message-attachment-card--${type}`]: type,
    })}
  >
    <div className="str-chat__message-attachment-card--content">
      <div className="str-chat__message-attachment-card--text">
        this content could not be displayed
      </div>
    </div>
  </div>
)

const MessagingLinkAttachmentCard = attachment => {
  const {
    author_name: authorName,
    image_url: imageUrlProp,
    og_scrape_url: ogScrapeUrl,
    text,
    thumb_url: thumbUrl,
    title,
    title_link: titleLink,
    type,
  } = attachment

  const url = titleLink || ogScrapeUrl
  const imageUrl = thumbUrl || imageUrlProp

  if (!title && !url && !imageUrl && !text) {
    return <UnableToRenderCard type={type} />
  }

  return (
    <BookingAttachmentCard
      bookingUrl={url}
      className="messaging-link-attachment-card"
      ctaText="Open Link"
      detailLine={text}
      imageUrl={imageUrl}
      locationName={authorName || getHostFromURL(url)}
      title={title || getHostFromURL(url)}
      type={type}
    />
  )
}

export default React.memo(MessagingLinkAttachmentCard)
